export const NUM_OF_ROWS = 4;
export const NUM_OF_COLS = 4;

export function constructSnippet({
  gridRow = null,
  gridCol = null,
} = {}) {
  const hasChild = gridRow !== null && gridCol !== null;

  const childCode = hasChild
    ? `\
grid-row: ${gridRow};
  grid-column: ${gridCol};`
    : `
`;

  const cssCode = `\
.parent {
  display: grid;
  grid-template-columns:
    repeat(${NUM_OF_COLS}, 1fr);
  grid-template-rows:
    repeat(${NUM_OF_ROWS}, 1fr);
}

.child {
  ${childCode}
}`;

  return cssCode;
}
